const baseUrl = process.env.REACT_APP_BASE_URL || 'https://localhost:44333/api/';

const PaymentApiService = {
    // Method for handling the signup API call
    
    Add : async (data) => {
      try {
        const apiEndpoint = baseUrl + 'Payment/Create'; // Complete URL for the signup endpoint
  
        const response = await fetch(apiEndpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data), // Convert data to JSON
        });
        
        if (!response.ok) {
          const errorData = await response.json(); 
          // throw new Error(errorData.message);
          return errorData;
        }
  
        const result = await response.json(); // Parse the JSON response
        return result; // Return response data on success
      } catch (error) {
        console.error('Add Payment error:', error);
        throw new Error(error);
      }
    },
  
    GetByUser: async (data) => {
      try {
        const apiEndpoint = `${baseUrl}Payment/Get/${data}`; // Complete URL for the test endpoint
  
        const response = await fetch(apiEndpoint, {
          method: 'GET', // Correctly capitalized method
          headers: {
            'Content-Type': 'application/json',
          },
        });
  
        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message || 'Error occurred');
        }
  
        const result = await response.json(); // Parse the JSON response
        return result; // Return response data on success
      } catch (error) {
        console.error('Error:', error);
        throw new Error('Network error');
      }
    },

    Get: async () => {
      try {
        const apiEndpoint = `${baseUrl}Payment/Get`; // Complete URL for the test endpoint
  
        const response = await fetch(apiEndpoint, {
          method: 'GET', // Correctly capitalized method
          headers: {
            'Content-Type': 'application/json',
          },
        });
  
        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message || 'Error occurred');
        }
  
        const result = await response.json(); // Parse the JSON response
        return result; // Return response data on success
      } catch (error) {
        console.error('Error:', error);
        throw new Error('Network error');
      }
    },
  
    Update: async (data) => {
      try {
        const apiEndpoint = `${baseUrl}Payment/Update`; // Complete URL for the signup endpoint
  
        const response = await fetch(apiEndpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data), // Convert data to JSON
        });
        
        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message || 'Error occurred');
        }
  
        const result = await response.json(); // Parse the JSON response
        return result; // Return response data on success
      } catch (error) {
        console.error('Update Payment error:', error);
        throw new Error('Network error');
      }
    },

    Delete: async (data) => {
        try {
         const apiEndpoint = `${baseUrl}Payment/Delete/${data}`; // Correct URL with `/`
    
          const response = await fetch(apiEndpoint, {
              method: 'DELETE', // Use DELETE instead of POST
              headers: {
                  'Content-Type': 'application/json',
              }
          });
          if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || 'Error occurred');
          }
    
          const result = await response.json(); // Parse the JSON response
          return result; // Return response data on success
        } catch (error) {
          console.error('Update Payment error:', error);
          throw new Error('Network error');
        }
      },
  };
  
  export default PaymentApiService;
  